import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { endpoints, environment } from "src/environments/environment";
import { AssistanceRequest } from "../model/assistanceRequest";
import { UrlUtilService } from "src/app/shared/service/url-util/url-util.service";
import { bookingMobilityHistoryRequest } from "../components/webform/webform-booking-history-list/model/bookingMobilityHistoryRequest";
import { infoRequestHistoryBody } from "../components/webform-info-history-list/model/infoRequestHistoryBody";

@Injectable({
  providedIn: "root",
})
export class SupportService {
  private SUPPORT_REQUEST_URL = endpoints.support_request;
  private RETRIEVE_TRIPLET = endpoints.retrieve_triplet;
  private RETRIEVE_TRIPLET_NOTLOGGED = endpoints.retrieve_triplet_notlogged;
  private CREATE_REQUEST = endpoints.create_request;
  private SEARCH_REQUEST_HISTORY = endpoints.search_request_history; //INSERIRE ENDPOINT CON FIRMA API
  private EXPORT_INFO_REQUESTS_HISTORY_URL = 'inserire endpoint' //INSERIRE ENDPOINT CON FIRMA API
  private SEARCH_BOOKINGS_MOBILITY = endpoints.search_bookings_mobility;
  private SEARCH_BOOKINGS_MOBILITY_NOT_LOGGED = endpoints.search_bookings_mobility_not_logged;
  private SEARCH_REQUESTS_NOT_LOGGED = endpoints.search_requests_not_logged;
  private ILOCATOR_SERVICE=endpoints.ilocator_service_center_by_plate;
  private GET_COD_COST_CENTER = endpoints.get_cod_cost_center;
  constructor(private http: HttpClient, private urlService: UrlUtilService) {}

  sendAssistanceRequest(request: AssistanceRequest) {
    return this.http.post(this.SUPPORT_REQUEST_URL, request);
  }

  getTripletWebform(customerRef) {
    const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
    if(customerRef==""){
      return this.http.post<Array<any>>(`${this.RETRIEVE_TRIPLET}`, {}, { headers });
    }
    else{
      return this.http.post<Array<any>>(`${this.RETRIEVE_TRIPLET}?customerRef=${customerRef}`, {}, { headers });
    }
  }

  getTripletWebformNotLogged() {
    const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
    
    return this.http.post<Array<any>>(`${this.RETRIEVE_TRIPLET_NOTLOGGED}`, {}, { headers });
  }

  createRequestWebform(formData: FormData, isLogged: boolean) {
    const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
    return this.http.post(`${this.CREATE_REQUEST}?isLogged=${isLogged}`, formData,{headers});
  }

  //METODO PER RECUPERARE LO STORICO DELLE RICHIESTE INFORMAZIONI WEBFORM
  getInfoRequestsHistory(body: infoRequestHistoryBody) {
    //TODO IMPLEMENTARE API
    return this.http.post(
			`${this.SEARCH_REQUEST_HISTORY}`, body
		)
  }

   //METODO PER EXPORT STORICO DELLE RICHIESTE INFORMAZIONI WEBFORM
   getInfoRequestsHistoryExport(a: any, b:any) {
    //TODO IMPLEMENTARE API
    return this.http.post(
			`${this.EXPORT_INFO_REQUESTS_HISTORY_URL}?${this.urlService.convertObjectToSearchParam(a)}`,
			{ maintenanceFilter: b },
			{ responseType: 'blob' as 'json' }
		)
  }

  // //METODO PER RECUPERARE LO STORICO DELLE PRENOTAZIONI WEBFORM
  // getBookingRequestsHistory(a: any, b:any, c:any) {
  //   //TODO IMPLEMENTARE API
  //   return this.http.post(
	// 		`${this.INFO_REQUESTS_HISTORY_URL}?customerId=${a}&${this.urlService.convertObjectToSearchParam(b)}`,
	// 		{
	// 			c,
	// 		}
	// 	)
  // }

  //METODO PER EXPORT STORICO DELLE PRENOTAZIONI WEBFORM
  getBookingRequestsHistoryExport(a: any, b:any) {
    //TODO IMPLEMENTARE API
    return this.http.post(
			`${this.EXPORT_INFO_REQUESTS_HISTORY_URL}?${this.urlService.convertObjectToSearchParam(a)}`,
			{ maintenanceFilter: b },
			{ responseType: 'blob' as 'json' }
		)
  }

  //METODO PER IL RECUPERO DEI CENTRI DI ASSISTENZA TRAMITE ILOCATOR PER WEBFORM
  getILocatorServiceCenter(params:any):any{
    const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
      'X-Skip-Interceptor': ""
		})
    return this.http.post(`${this.ILOCATOR_SERVICE}`,
      {serviceCentersListFilter: params}, { headers}
    );    //TODO rimuovere il requiered anche lato be non serve piu il page size
  }

  //METODO PER IL RECUPERO DELLE BOOKINGS MOBILITY
  getBookingsMobility(body: bookingMobilityHistoryRequest) {
    return this.http.post(`${this.SEARCH_BOOKINGS_MOBILITY}`, body);
  }

  getBookingsMobilityNotLogged(id: any) {
    const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
    return this.http.post(`${this.SEARCH_BOOKINGS_MOBILITY_NOT_LOGGED}?idPratica=${id}`, {},{ headers });
  }

  getRequestsNotLogged(caseNumber: any, customerCode) {
    const headers = new HttpHeaders({
			'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
			'x-ald-subscription-key': environment.xAldSubscriptionKey,
		})
    return this.http.get(`${this.SEARCH_REQUESTS_NOT_LOGGED}?customerCode=${customerCode}&caseNumber=${caseNumber}`,{ headers });
  }

  getCodCostCenter(codPlate: string) {
    return this.http.get(`${this.GET_COD_COST_CENTER}?codPlate=${codPlate}`);
	}

}
